import { type UserConvoAIStreamingConfig } from '@atlassian/ai-agent-streaming';
import type {
	AiFeatureRequestEnvelopeContentCatchupRequest,
	ContentUpdateType,
} from '@atlassian/convo-ai-api';

export type SummaryRequestBuilderType = {
	contentAri: string;
	locale: string;
	updateType: ContentUpdateType;
	endTimeMs: number;
	selectedVersions?: Set<any>;
	enablePartialJson?: boolean;
};

export const buildCatchupRequest = ({
	contentAri,
	locale,
	updateType,
	endTimeMs,
	selectedVersions,
	enablePartialJson = false,
}: SummaryRequestBuilderType): [
	AiFeatureRequestEnvelopeContentCatchupRequest,
	UserConvoAIStreamingConfig,
] => {
	return [
		{
			ai_feature_input: {
				content_ari: contentAri,
				locale,
				update_type: updateType,
				end_time_ms: endTimeMs,
				...(selectedVersions && {
					original_content_version: Math.min(...Array.from(selectedVersions)),
					revised_content_version: Math.max(...Array.from(selectedVersions)),
				}),
			},
		},
		{
			apiPath: 'v2/ai-feature/confluence-content-catchup',
			delayChunkUpdate: { gap: 10, time: 20 },
			enablePartialJson,
			headers: {
				'x-experience-id': 'catchup-version-summary',
				'x-product': 'confluence',
			},
		},
	];
};
